import {React, useState, useRef, useCallback} from 'react';

import constants from "../../../constants.js"
import styles from './table.module.css'


const Table = ({headers, headerColor, defaultHeader, tableKeys, tableData, setTableData, canSort}) => {
  const tableRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const scrollLeftRef = useRef(0);
  const startXRef = useRef(0);

  const [sortBy, setSortBy] = useState({
    col: headers[0].value,
    type: ""
  });

  const onMouseDown = (e) => {
    setIsDragging(true);
    startXRef.current = e.pageX - tableRef.current.offsetLeft;
    scrollLeftRef.current = tableRef.current.scrollLeft;
  };

  const onMouseMove = useCallback((e) => {
    if (!isDragging) return;
    requestAnimationFrame(() => {
      if (!tableRef.current) return;
      const x = e.pageX - tableRef.current.offsetLeft;
      const walk = x - startXRef.current;
      tableRef.current.scrollLeft = scrollLeftRef.current - walk;
    });
  }, [isDragging]);

  const onMouseUp = () => {
    setIsDragging(false);
    if (document.selection) {
      document.selection.empty()
    } else {
      window.getSelection().removeAllRanges()
    }
  };

  const onMouseLeave = () => {
    setIsDragging(false);
  };

  // No need to duplicate the table data here and in the parent, so to sort we update the state of the parent with the sorted data.
  // Does this make sense? I hope so
  const sortTable = (e) => {

    let header = e.currentTarget.id;
    if (header == constants.fullName) header = constants.lastName; 
    if (header == constants.fullTeam) header = constants.teamName; 

    let newSortType = '';
    switch(sortBy.type) {
      case 'asc':
        newSortType = '';
        break;
      case 'dsc':
        newSortType = 'asc';
        break;
      case '':
        newSortType = 'dsc';
        break;
    }

    const sortedData = [...tableData];
    
    sortedData.sort((a, b) => {
      // If the header values are strings, ignore case by making them all upper
      let newA = a[header];
      let newB = b[header];
      if (typeof newA == "string") newA = newA.toUpperCase();
      if (typeof newB == "string") newB = newB.toUpperCase();

      if (newSortType == ''){
        newA = a[defaultHeader];
        newB = b[defaultHeader];
        if (typeof newA == "string") newA = newA.toUpperCase();
        if (typeof newB == "string") newB = newB.toUpperCase();

        if (newA < newB) return 1
        if (newA > newB) return -1;
        return 0;
      }
      else if (newSortType == 'dsc'){
        if (newA < newB) return -1
        if (newA > newB) return 1;
        return 0;
      }
      else if (newSortType == 'asc') {
        if (newA < newB) return 1
        if (newA > newB) return -1;
        return 0;
      }
      
    });

    setTableData(sortedData);
    setSortBy({col: newSortType == '' ? defaultHeader : e.currentTarget.id, type: newSortType});
  }

  return (
    <div 
      ref={tableRef}
      className={styles.TableContainer}
      style={{cursor: `${isDragging ? 'grabbing' : 'grab'}`}}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}>
      <table className={styles.Table}>

        <thead className={styles.HeaderRow}>
          <tr>
            {headers && headers.map((header, i) => {
              return (
                <th 
                onClick={canSort ? sortTable : ()=>{}} 
                className={`${styles.Header} ${i==0 || i==1 ? styles.StickyHeader : ""}`} 
                style={{
                  left: i==1 ? '7em' : '0',
                  textAlign:'center',
                  fontWeight: (header.value == sortBy.col && sortBy.type != "") ? "bold" : "normal",  
                  background: `${headerColor ? headerColor : constants.colors.cplWhite}`,
                  color: `${headerColor ? constants.colors.cplWhite : constants.colors.cplNavy}`,
                  boxShadow: `${headerColor ? "0 0 0 0" : "inset 0px -1px 0px 0px var(--cpl-navy), inset 0px 1px 0px 0px var(--cpl-navy)"}`}} 
                id={header.value} 
                key={header.value}>
                  <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                    {(window.innerWidth<1200 && header.shortLabel) ? header.shortLabel : header.label} {(header.value==sortBy.col && sortBy.type != "") && <img src={"/icons/" + sortBy.type +".svg"}/>}
                    </div>
                </th>
              )
            })}
          </tr>
        </thead>

        <tbody className={styles.Body}>
          {tableData && tableData.map((element, i) => {
            const background = i%2 == 1 ? constants.colors.cplWhite : constants.colors.cplGray;
            const key = tableKeys.map(key => element[key]).join('_');
            const uniqueKey = i + "_" + key;
            return (<tr className={styles.Row} style={{backgroundColor: background}} key={uniqueKey}>
              {headers.map((item, i) => {
                return (
                  <td className={`${styles.Cell} ${i==0 || i==1 ? styles.StickyCell : ""}`} style={{background: background, textAlign:item.text, left:i==1 ? '7em' : '0'}} key={`${uniqueKey}_${item.value}`}>
                    <div>{element[item.value]}</div>
                  </td>
                )
              })}
            </tr>)
          })}
        </tbody>

      </table>
    </div>

  )
}

export default Table;